import { render, staticRenderFns } from "./FlatDetails.vue?vue&type=template&id=2f13f07b&"
import script from "./FlatDetails.vue?vue&type=script&lang=js&"
export * from "./FlatDetails.vue?vue&type=script&lang=js&"
import style0 from "./FlatDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports